// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"94659427","198":"94659427","252":"94659427","354":"94659427","578":"94659427","687":"94659427","785":"94659427","935":"94659427"}[chunkId] + ".chunk.css";
};